import axios from 'axios';

const API = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

export const register = (username, password) => 
  API.post('/register', { username, password });

export const login = (username, password) => 
  API.post('/login', { username, password });

export const logout = () => 
  API.post('/logout');

export const getMe = () => 
  API.get('/me');

export const getChats = () => 
  API.get('/chats');

export const getMessages = (user) => 
  API.get(`/messages/${user}`);

export const sendMessage = (to, text) => {
  console.log('📤 API отправка:', { to, text });
  return API.post('/messages', { to, text });
};

export const getAllUsers = () => 
  API.get('/users');

export const getUserData = (username) => 
  API.get(`/user/${username}`);

export const deleteChat = (username) => 
  API.delete(`/admin/chat/${username}`);

export const editMessage = (messageId, text) => 
  API.put(`/messages/${messageId}`, { text });

export const deleteMessage = (messageId) => 
  API.delete(`/messages/${messageId}`);

export const changeUsername = (newUsername) => 
  API.put('/user/username', { username: newUsername });

export const changeAvatar = async (avatar) => {
  const response = await API.put('/user/avatar', { avatar });
  return response.data;
};

// Админские
export const getUsers = () => 
  API.get('/admin/users');

export const banUser = (username) => 
  API.post('/admin/ban', { username });

export const unbanUser = (username) => 
  API.post('/admin/unban', { username });

export const deleteUser = (username) => 
  API.delete(`/admin/user/${username}`);

export const getStats = () => 
  API.get('/admin/stats');
